import fetch from 'isomorphic-fetch';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
var contentfulBaseUri = 'https://graphql.contentful.com';

var createContentfulApolloClient = function createContentfulApolloClient(_ref) {
  var spaceId = _ref.spaceId,
      token = _ref.token,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? 'Master' : _ref$environment;
  var httpLink = createHttpLink({
    uri: "".concat(contentfulBaseUri, "/content/v1/spaces/").concat(spaceId, "/environments/").concat(environment),
    fetch: fetch
  });
  var middlewareLink = new ApolloLink(function (operation, forward) {
    var headers = {
      authorization: "Bearer ".concat(token),
      'content-type': 'application/json'
    };
    operation.setContext({
      headers: headers
    });
    return forward ? forward(operation) : null;
  });
  var fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
      __schema: {
        types: []
      }
    }
  });
  var cache = new InMemoryCache({
    fragmentMatcher: fragmentMatcher
  });
  return new ApolloClient({
    link: middlewareLink.concat(httpLink),
    cache: cache // query: {
    //   fetchPolicy: 'cache-and-network',
    //   errorPolicy: 'all',
    // },

  });
};

export { createContentfulApolloClient };